import React from 'react'

const ListBrandsContext = React.createContext({})

export default ListBrandsContext
